<template>
<v-app id="app">

  <router-view></router-view>

  <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="2500">{{
      snackbarMessage
    }}</v-snackbar>

</v-app>
</template>

<script>
// @ is an alias to /src
import EventBus, {
  ACTIONS
} from "./components/MySnackbar/EventBus"

export default {
  name: 'App',
  data: () => ({
    snackbar: false,
    snackbarColor: '',
    snackbarMessage: "",
    //
    // drawer: false,
    // items: [{
    //     title: 'داشبورد',
    //     icon: 'mdi-view-dashboard',
    //     shortkey: 'esc'
    //   },
    //   {
    //     title: 'Account',
    //     icon: 'mdi-account-box'
    //   },
    //   {
    //     title: 'Settings',
    //     icon: 'mdi-cog'
    //   },
    // ],
  }),
  methods: {
    // esc() {
    //   alert('sad')
    //   this.$store.dispatch("logout")
    // }
  },
  mounted() {
    EventBus.$on(ACTIONS.SNACKBAR, (message, color) => {
      this.snackbarMessage = message;
      this.snackbarColor = color;
      this.snackbar = true;
    });
  },
  created() {
    this.$vuetify.rtl = true
  },
};
</script>

<style lang="scss">
//
@font-face {
    font-family: iransans_ul;
    src: url("./assets/fonts/IRANSans_UltraLight.ttf") format('truetype');
    font-weight: normal;
}
@font-face {
    font-family: yekan;
    src: url("./assets/fonts/yekan.eot");
    src: url("./assets/fonts/yekan.eot?#iefix") format('embedded-opentype'), url("./assets/fonts/yekan.woff") format('woff'), url("./assets/fonts/yekan.ttf") format('truetype');
    font-weight: normal;
}
@font-face {
    font-family: titr;
    src: url("./assets/fonts/BTITRBD.eot");
    src: url("./assets/fonts/BTITRBD.eot?#iefix") format('embedded-opentype'), url("./assets/fonts/BTITRBD.woff") format('woff'), url("./assets/fonts/BTITRBD.TTF") format('truetype');
    font-weight: normal;
}
#app,
h1,
h2,
h3,
h4,
h5 {
    font-family: yekan;
}
.mytitle {
    font-size: 30px;
}
</style>
